<template>
    <!-- 直播回放 -->
    <div class="container">
        <LiveLecture :froliveArrm="froliveArrm" :active="active"></LiveLecture>
    </div>
</template>
<script>
import LiveLecture from './LiveLecture.vue';
export default {
    name:'LivePlayback',
    props: ["froliveArrm",'active'],
    data(){
        return {
            
        }
    },
    components:{
        LiveLecture
    }
}
</script>



// WEBPACK FOOTER //
// src/components/teacher/LivePlayback.vue